import {
    useState,
    useEffect
}
from "react";

import {
    functions
}
from "../../../constants/common-functions";

export default function useSpaceOrgDashboard()
{
    const [dashboard, setDashboard] =
        useState(null);
		
		

    useEffect(
        function()
        {
            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/spaceorgdashboard",
                function(obj)
                {
                  
                    setDashboard(obj);
                },
                null
            );
        },
        []
    );

    if(!dashboard)
    {
        return {
            kpis: {},
            spaceBreakdown: [],
            topBuildings: [],
            topSpaces: [],
            buildingBreakdown: [],
            selectedBuilding: null,
            topFloors: []
        };
    }

    const kpis =
        dashboard.kpis;

		const spaceBreakdown =
		   dashboard.spaceBreakdown;

    const topBuildings =
        dashboard.topBuildings;

    const selectedBuilding =
    {
        id:
            dashboard.selectedBuildingId,

        name:
            dashboard.selectedBuildingName
    };

    const topSpaces =
        [];

    const buildingBreakdown =
        [];

    const topFloors =
        [];

    return {
        kpis,
        spaceBreakdown,
        topBuildings,
        topSpaces,
        buildingBreakdown,
        selectedBuilding,
        topFloors
    };
}